$(document).ready(function() {

  // Fixed header logic
  var scrollTimer;
  var $window = $(window);
  var $fixedHeader = $('.fixed-header');
  var isSticky = false;

  $fixedHeader.find('.main-menu').append($('.main-header .main-menu').html());

  $window.scroll(function(e) {
    var scroll = $window.scrollTop();
    var hiddenTop;
    var targetHeight;

    if ($('body').hasClass('single-product')) {
      hiddenTop = -200;
      targetHeight = $('.main-header').height() + $('.woocommerce-breadcrumb').height() + 50;
    } else {
      hiddenTop = -50;
      targetHeight = $('.main-header').height();
    }

    if (scrollTimer) { 
      window.clearTimeout(scrollTimer); 
      scrollTimer = null;
    }

    scrollTimer = window.setTimeout(function(){
      if (!isSticky && (scroll > targetHeight) && $fixedHeader.position().top == hiddenTop) {
        isSticky = true;
        $fixedHeader.animate({
          top: 0
        }, 500);
        $('body').addClass('has-fixed-header');
      } else {
        if (isSticky && (scroll <= targetHeight) && $fixedHeader.position().top <= 0) {
          isSticky = false;
          $fixedHeader.animate({
            top: hiddenTop
          }, 500);
          $('body').removeClass('has-fixed-header');
          showHideCart($('.fixed-header .cart-popover'), true);
        }
      }
    }, 1);
  });

  // Search show
  $('.icons-menu .icon-search').on('click', function() {
    var $this = $(this);
    $this.closest('a').hide();
    $this.closest('li').find('.search-form').css('width', '100%').find('input').focus();
  });

  $('.icons-menu .icon-x_button').on('click', function() {
    var $this = $(this);
    $this.closest('li').find('.search-form').css('width', '0');
    setTimeout(function() {
      $this.closest('li').children('a').show();
    }, 500);
  });

  // Mobile
  $(window).resize(function() {

    if ($(window).width() <= 992) {
      // phones & medium
      
      // when clicking on the products parent menu item, slide the children form the right
      $('.menu-products > a').on('click', function(e) {
        e.preventDefault();
        // prevent body scrolling
        $('body').addClass('lock-position');
        // set the height of the the .row container to the available space
        var topBarsHeight = $(".top-bar").height() + $(".main-header").height();
        var viewportHeight = $( window ).height();
        $('.wr-megamenu-inner .row').css("height", viewportHeight - topBarsHeight );
        // start the transition to move .wr-megamenu-container to the left, so .wr-megamenu-inner is shown
        $(this).closest('.wr-megamenu-container').addClass('slide');
        $('.wr-megamenu-inner').addClass('active');
      });

      // remove the original href that is rendered on the producst menu item
      $('.menu-products > a').attr('href', 'javascript:void(0)');

      // when clicking hamburger menu
      $('.it-responsive-mega').on('click', function() {
        // recover body overflow just in case
        $('body').removeClass('lock-position');
      });

      if ( $(window).width() <= 768 ) {
        // phones
        
        $('.wr-megamenu-container').each(function(){
          this.style.setProperty('background-color', 'rgba(241,241,241,0.95)', 'important');
        });
        if (!$('.back').length) {
          $('.jsn-bootstrap3 .row').before('<div class="back"><a href="javascript:void(0)"><span class="icon-arrow"></span>Back</a></div>');
        }
        // Back button on the child menu items
        $('.back a').on('click', function(e) {
          $(this).closest('.wr-megamenu-container').removeClass('slide');
          $(this).closest('.wr-megamenu-inner').removeClass('active');
          // recover body overflow just in case
          $('body').removeClass('lock-position');
        });
        $('.main-header .icons-menu .search-form').insertBefore('.menu-products');
      
      } else {
        // Medium
        $('.wr-megamenu-container').each(function(){
          this.style.setProperty('background-color', 'transparent', 'important');
        });
        $('.wr-megamenu-container .search-form').remove();
        $('.jsn-bootstrap3 > .back').remove();
      }

    } else {
      // desktop
      $('.menu-products > a').attr('href', '/products');
      $('.wr-megamenu-container').each(function(){
        this.style.setProperty('background-color', 'transparent', 'important');
      });
      $('.wr-megamenu-container .search-form').remove();
      $('.jsn-bootstrap3 > .back').remove();
    }

  }).trigger('resize');

});
